import { useEffect, useRef, useCallback } from 'react'

type AnimationFrameCallback = (time: number) => void

export const useAnimationFrame = (callback: AnimationFrameCallback): void => {
  const requestRef = useRef<number | null>(null)
  const previousTimeRef = useRef<number | null>(null)

  const animate = useCallback(
    (time: number) => {
      if (previousTimeRef.current !== null) {
        const deltaTime = time - previousTimeRef.current
        callback(deltaTime)
      }
      previousTimeRef.current = time
      requestRef.current = requestAnimationFrame(animate)
    },
    [callback],
  )

  useEffect(() => {
    const animateCallback = () => animate(performance.now())

    requestRef.current = requestAnimationFrame(animateCallback)

    return () => {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current)
      }
    }
  }, [callback, animate])
}
